import { render, staticRenderFns } from "./QueueMOH.vue?vue&type=template&id=7cec7801"
import script from "./QueueMOH.vue?vue&type=script&lang=ts"
export * from "./QueueMOH.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports